import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineDoseDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineDose/GetDetail?` + params, null);

export const GetMedicineDoseList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineDose/GetList?` + params, null);

export const CreateMedicineDose = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDose/Create`, data);

export const UpdateMedicineDose = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDose/Update`, data);    

export const DeleteMedicineDose = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicineDose/Delete`, data);

export const GetMedicineDoseListForOPD = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicineDose/GetListForOPD?` + params, null);
